export const BRAND = {
  name: 'SAP3D',
  shortName: 'SAP3D',
  tagline: 'Internal model studio',
  // End users only customize the models we ship (see public/models/models.json).
  // Set VITE_ALLOW_EDITING=true at build/dev time to expose the source editor
  // and file browser (the e2e suite does this).
  allowEditing: import.meta.env.VITE_ALLOW_EDITING === 'true',
};
